'use client';

import { useGtmChannel } from '@/hooks/useGtmChannel';
import { useSessionLandingCampaign } from '@/hooks/useSessionLandingCampaign';

/** 캠페인 랜딩을 거쳐 온 탭에서는 어느 페이지에서 클릭하든 GA4 funnel=<slug> 가 붙게 한다 */
const LandingCampaignGtmChannel = () => {
  const [landingCampaign] = useSessionLandingCampaign({ initializeWithValue: false });
  useGtmChannel(landingCampaign?.slug);
  return null;
};

export default LandingCampaignGtmChannel;
